import React from "react";
import styles from "./downloads.module.css";

const Downloads = () => {
  return (
    <div className={styles.container}>
      <h1 className={styles.heading}>Downloads</h1>

      <div className={styles.grid}>
        {/* Edition 1 */}
        <div className={styles.card}>
          <img
            src="/assets/images/edition1.jpg"
            alt="ICETMCP-2026 Edition 1"
            className={styles.image}
          />

          <div className={styles.content}>
            <h2>ICETMCP-2026 (Edition 1)</h2>
            <p>
              First edition of the ICETMCP-2026 conference proceedings.
            </p>

            <a
              href="/assets/Final Proceedings (ICETMCP-2026) Edition 1.pdf"
              download
              className={styles.button}
            >
              Download Proceedings
            </a>
          </div>
        </div>

        {/* Edition 2 */}
        <div className={styles.card}>
          <img
            src="/assets/images/edition2.jpg"
            alt="ICETMCP-2026 Edition 2"
            className={styles.image}
          />

          <div className={styles.content}>
            <h2>ICETMCP-2026 (Edition 2)</h2>
            <p>
              Second edition of the ICETMCP-2026 conference proceedings.
            </p>

            <button className={styles.upcomingButton} disabled>
              ✨ Upcoming
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Downloads;